import { useHistory, useParams } from 'react-router-dom'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useFetchedData from 'hooks/useFetchedData'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import Payment from 'components/Payments'
import Loading from 'components/Loading'
import { toLongDate } from 'utils/date'
import * as urls from 'rest/urls'
import React from 'react'
import './style.scss'

interface ResponseInvoice {
  id: string
  object?: string
  correctedInvoiceId?: string
  proformaInvoiceId?: string
  fullNumber: string
  description?: string
  currency: string
  documentDate: string
  salesDate: string
  paymentDeadline: string
  netAmount: string
  taxAmount: string
  grossAmount: string
  remainingAmount: string
  isPaid: boolean
  contractor_type: string
  issuerCompanyId: string
  issuerName: string
  issuerShortName: string
  link: string
}

interface Response {
  userId: string
  invoice: ResponseInvoice
  methods: undefined
}

const PayInvoice: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const url = id ? urls.paymentParams(id) : ''
  const { isLoading, data } = useFetchedData<Response>(url, '', 'POST')

  const { replace } = useHistory()
  const { t, lang } = useTranslation('account')

  if (isLoading) {
    return <Loading middleOfPage />
  }

  if (data?.userId && !data?.invoice.isPaid) {
    return (
      <Payment
        userId={data.userId}
        secondaryTheme={false}
        additionalElement={<div className='payment__additional'>
          <div>
            <div className='payment__additional__title'>{data.invoice.fullNumber}</div>
            <div className='payment__additional__desc'>{toLongDate(data.invoice.paymentDeadline, lang, true)} <span className='dot' /> {displayPrice(data.invoice.remainingAmount)}</div>
          </div>
          {data.invoice.link && <i
            className='icon icon--download'
            onClick={() => {
              window.open(data.invoice.link, '_blank')
            }}
          />}
        </div>}
        summaryBottom='1'
        summaryTop={t('numberOfInvoices')}
        grossPrice={Number(data.invoice.remainingAmount)}
        getInvoices={() => {
          return [{
            invoiceId: data.invoice.id,
            amount: data.invoice.remainingAmount,
            object: data.invoice.object
          }]
        }}
        paymentMethods={data.methods}
        close={(remotePaymentId: string) => {
          if (remotePaymentId) {
            setTimeout(() => replace('/'), 100)
          } else {
            replace('/')
          }
        }}
      />
    )
  }

  return (
    <div className='payInvoice'>
      <div className='payInvoice__text'>{t(data?.invoice?.isPaid ? 'invoiceHasAlreadyBeenPaid' : 'failedToRetrieveInvoicePaymentData')}</div>
      <ArrowBtn
        enlarged
        text={t('backToApp')}
        action={() => {
          replace('/')
        }} />
    </div>
  )
}

export default PayInvoice